var poll_header_default = {
  "title": "VbvUz",
  "image": "ZlCiP",
  "webview": "uV7JT"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
